import { PRODUCT_DATA } from "@/polymet/data/product-data";
import ProductHeader from "@/polymet/components/product-header";
import ProductTitleBanner from "@/polymet/components/product-title-banner";
import MarketOpportunityCard from "@/polymet/components/market-opportunity-card";
import ConsumerFeedbackTable from "@/polymet/components/consumer-feedback-table";
import FormulationTable from "@/polymet/components/formulation-table";
import MarketInfoCard from "@/polymet/components/market-info-card";
import SupplyAvailabilityTable from "@/polymet/components/supply-availability-table";
import ProcessingStepsCard from "@/polymet/components/processing-steps-card";

export default function ProductDashboard() {
  const {
    productName,
    productImage,
    marketOpportunity,
    consumerFeedback,
    formulation,
    marketInformation,
    supplyAvailability,
    processingSteps,
  } = PRODUCT_DATA;

  return (
    <div className="min-h-screen bg-slate-50">
      <ProductHeader />

      <div className="container mx-auto p-4 max-h-[calc(100vh-76px)] overflow-hidden">
        <div className="grid grid-cols-12 gap-4 h-full">
          {/* Product Image and Market Info */}
          <div className="col-span-12 md:col-span-3 flex flex-col gap-4">
            <div className="bg-amber-50 rounded-lg p-4 flex justify-center items-center">
              <img
                src={productImage}
                alt={productName}
                className="max-h-[240px] object-contain"
              />
            </div>
            <div className="flex-grow">
              <MarketInfoCard marketInfoItems={marketInformation} />
            </div>
          </div>

          {/* Main Content */}
          <div className="col-span-12 md:col-span-9 flex flex-col gap-4">
            <ProductTitleBanner productName={productName} />

            <div className="grid grid-cols-12 gap-4">
              {/* Market Opportunity */}
              <div className="col-span-12 md:col-span-5">
                <MarketOpportunityCard
                  costReduction={marketOpportunity.costReduction}
                  marketValue={marketOpportunity.marketValue}
                />
              </div>

              {/* Consumer Feedback */}
              <div className="col-span-12 md:col-span-7">
                <ConsumerFeedbackTable feedbackItems={consumerFeedback} />
              </div>
            </div>

            {/* Formulation */}
            <div className="w-full">
              <FormulationTable
                originalIngredients={formulation.originalIngredients}
                replacementIngredients={formulation.replacementIngredients}
                functionalImprovements={formulation.functionalImprovements}
                nutritionalImprovements={formulation.nutritionalImprovements}
              />
            </div>

            <div className="grid grid-cols-12 gap-4">
              {/* Supply Availability */}
              <div className="col-span-12 md:col-span-7">
                <SupplyAvailabilityTable
                  byproduct={supplyAvailability.byproduct}
                  volume={supplyAvailability.volume}
                  productVolume={supplyAvailability.productVolume}
                  suppliers={supplyAvailability.suppliers}
                />
              </div>

              {/* Processing Steps */}
              <div className="col-span-12 md:col-span-5">
                <ProcessingStepsCard steps={processingSteps} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
